import React from "react";
import * as FiIcons from "react-icons/fi";
import { SettingsCard, SettingsNotice } from "./SettingsPanel";

const { FiSliders } = FiIcons;

const unavailablePreferences = [
  "Date format",
  "Number format",
  "Theme preference",
  "Email notifications",
  "Product updates",
  "Accounting notifications",
];

export default function PreferencesSettings() {
  return (
    <SettingsCard
      title="Preferences"
      description="Display and notification options for your client portal."
      icon={FiSliders}
    >
      <SettingsNotice>
        Preferences are not saved: this project has no confirmed client-preference storage or notification delivery mechanism. These options are unavailable until backend support is approved.
      </SettingsNotice>

      <div className="mt-5 grid gap-3 sm:grid-cols-2">
        {unavailablePreferences.map((preference) => (
          <div
            key={preference}
            aria-disabled="true"
            className="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3"
          >
            <span className="text-sm font-medium text-slate-600">
              {preference}
            </span>
            <span className="shrink-0 rounded-full bg-white px-2.5 py-1 text-[10px] font-semibold text-slate-500">
              Unavailable
            </span>
          </div>
        ))}
      </div>
    </SettingsCard>
  );
}